import {
  RECORDING_TOAST_DEFAULT_WIDTH,
  RecordingToastPosition,
  RecordingToastSize,
  ViewportSize,
} from '../config';

import {
  clampRecordingToastPosition,
  getDefaultRecordingToastPosition,
  readRecordingToastPosition,
} from './recordingToastPosition';

export const getViewportSize = (): ViewportSize => ({
  height: window.innerHeight,
  width: window.innerWidth,
});

export const getToastSize = (
  toastElement: HTMLDivElement | null,
): RecordingToastSize => {
  const rect = toastElement?.getBoundingClientRect();

  return {
    height: rect?.height || 0,
    width: rect?.width || RECORDING_TOAST_DEFAULT_WIDTH,
  };
};

export const getInitialRecordingToastPosition = ({
  currentUserID,
  toastElement,
}: {
  currentUserID: string;
  toastElement: HTMLDivElement | null;
}): RecordingToastPosition => {
  const size = getToastSize(toastElement);
  const viewport = getViewportSize();
  const storedPosition = currentUserID
    ? readRecordingToastPosition({
        storage: window.localStorage,
        userID: currentUserID,
      })
    : null;

  if (storedPosition) {
    return clampRecordingToastPosition({
      position: storedPosition,
      size,
      viewport,
    });
  }

  return getDefaultRecordingToastPosition({ size, viewport });
};
